import { useContext } from 'react'
import VerifyContext from 'app/contexts/VerifyContext'

const useVerify = () => useContext(VerifyContext)

export default useVerify
